import { BookingSummary, HotelDetails } from '@/domain/BookingSummary'

export default {
  bookingDetails: BookingSummary.empty(),
  hotelDetails: HotelDetails.empty(),
  bookingCheckinCheckoutInfo: {}
}
